import React from 'react';
import AppPillSwitch from './AppPillSwitch';

/**
 * Alias kit de AppPillSwitch (API `items`).
 * Préférer AppPillSwitch directement pour les nouveaux écrans.
 */
const AppTabs = ({
  items = [],
  value,
  onChange,
  className = '',
  ariaLabel = 'Onglets',
  disabled = false,
}) => (
  <AppPillSwitch
    className={className}
    ariaLabel={ariaLabel}
    value={value}
    onChange={onChange}
    disabled={disabled}
    options={items.map((item) => ({
      value: item.value,
      label: item.label,
      icon: item.icon,
      hint: item.hint,
      count: item.count,
      suffix: item.suffix,
      disabled: item.disabled,
    }))}
  />
);

export default AppTabs;
